import request from './base'

export const getWorkOrderList = (data) => {
    return request.post("/merchant/v1/workorder/list", data)
}

export const addWorkOrder = (data) => {
    return request.post("/merchant/v1/workorder/add", data)
}

// 获取签名
export const uploadPutFileSign = (params) => {
    return request.post("/merchant/v1/workorder/uploadSign", params)
}

//传输文件数据
export const uploadPutFile = (url, params, callBack, type) => {
    return request.uploadPutFile(url, params, callBack, type)
}

// 下载文件
export const getDownloadUrl = (data) => {
    return request.post("/merchant/v1/workorder/getDownloadUrl", data)
}

// 修改工单
export const updateWorkeorder = (data) => {
    return request.post("/merchant/v1/workorder/updateWorkeorder", data)
}


//创建续费订单
export const createRecharge = (data) => {
    return request.post("/merchant/v1/workorder/createRecharge", data)
}

// 续费订单列表
export const rechargeList = (data) => {
    return request.post("/merchant/v1/workorder/rechargeList", data)
}

// 获取续费订单详情
export const getRechargeDetail = (data) => {
    return request.post("/merchant/v1/workorder/getRechargeDetail", data)
}

// 修改续费订单
export const updateRecharge = (data) => {
    return request.post("/merchant/v1/workorder/updateRecharge", data)
}

// 获取支付连接
export const callAlipay = (data) => {
    return request.post("/merchant/v1/workorder/callAlipay", data)
}

export const rechargeCallback = (data) => {
    return request.post("/merchant/v1/workorder/rechargeCallback", data)
}

// 查询支付状态
export const queryPaymentStatus = (data) => {
    return request.post("/merchant/v1/workorder/queryPaymentStatus", data)
}

// 取消续费订单
export const cancelRecharge = (data) => {
    return request.post("/merchant/v1/workorder/cancelRecharge", data)
}




// WEBPACK FOOTER //
// ./src/api/workorder.js